import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import truuna from '../../assets/agriculture/truuna.png';
import suru from '../../assets/agriculture/suru.png';
import serving from '../../assets/hospitility/serving.png';
import HeroPopup from '../../webpopup/HeroPopup';


function Hero() {
  const [hoverTimer, setHoverTimer] = useState(null);
  const [showInfo, setShowInfo] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const products = [
    {
      id: 1,
      name: 'SURU15',
      image: suru,
      description:
        'शेण उचलणारा रोबोटिक युनिट - An automated waste management robotic unit engineered for efficient barn cleaning and livestock facility maintenance, featuring intelligent navigation and high-capacity waste collection capabilities for modern farming operations.',
    },
    {
      id: 2,
      name: 'GaDaI (गडी)',
      image: serving,
      description:
        'Guided Automated Delivery Assistance to Individuals - An advanced delivery robot system providing efficient and reliable service in hospitality environments, featuring obstacle avoidance, multi-floor navigation, and secure compartment storage for seamless guest service.',
    },
    {
      id: 3,
      name: 'TRUUNA',
      image: truuna,
      description:
        'Tractive Robotic Unmanned Universal Natural-farming Assistant - An advanced autonomous farming solution designed to revolutionize agricultural practices with precision navigation, intelligent crop management, and sustainable farming techniques for modern agriculture.',
    },
  ];

  const startShowTimer = (productId) => {
    const timer = setTimeout(() => {
      setShowInfo(productId);
    }, 2000);
    setHoverTimer(timer);
  };

  const clearShowTimer = () => {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
    }
    setHoverTimer(null);
    setShowInfo(null);
  };

  const handleClick = (product) => {
    setSelectedProduct(product);
  };

  const closePopup = () => {
    setSelectedProduct(null);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1>🚀 Innovation-Driven Robotics & Electronics Solutions</h1>
            <p>
              Custom electronic product development, embedded systems, IoT applications, and
              AI/ML solutions for industrial automation and beyond.
            </p>
            <div className="hero-cta">
              <Link to="/services" className="btn btn-primary">
                ⚙️ Our Services
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                💬 Get in Touch
              </Link>
            </div>
          </div>

          <div className="hero-visual">
            <div
              className="hero-item hero-item-1"
              onMouseEnter={() => startShowTimer(1)}
              onMouseLeave={clearShowTimer}
            >
              <div
                className="hero-box"
                onClick={() => handleClick(products[0])}
                aria-hidden
              >
                <img src={products[0].image} alt={products[0].name} />
              </div>

              {showInfo === 1 && (
                <div className="hero-tooltip hero-tooltip-1">
                  <div className="hero-tooltip-arrow" />
                  <h4>{products[0].name}</h4>
                  <p>{products[0].description}</p>
                </div>
              )}
            </div>

            <div
              className="hero-item hero-item-2"
              onMouseEnter={() => startShowTimer(2)}
              onMouseLeave={clearShowTimer}
            >
              <div
                className="hero-box"
                onClick={() => handleClick(products[1])}
                aria-hidden
              >
                <img src={products[1].image} alt={products[1].name} />
              </div>

              {showInfo === 2 && (
                <div className="hero-tooltip hero-tooltip-2">
                  <div className="hero-tooltip-arrow" />
                  <h4>{products[1].name}</h4>
                  <p>{products[1].description}</p>
                </div>
              )}
            </div>

            <div
              className="hero-item hero-item-3"
              onMouseEnter={() => startShowTimer(3)}
              onMouseLeave={clearShowTimer}
            >
              <div
                className="hero-box"
                onClick={() => handleClick(products[2])}
                aria-hidden
              >
                <img src={products[2].image} alt={products[2].name} />
              </div>

              {showInfo === 3 && (
                <div className="hero-tooltip hero-tooltip-3">
                  <div className="hero-tooltip-arrow" />
                  <h4>{products[2].name}</h4>
                  <p>{products[2].description}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {selectedProduct && <HeroPopup product={selectedProduct} onClose={closePopup} />}
    </>
  );
}

export default Hero;